import script from "./myBookings.vue?vue&type=script&setup=true&lang=js"
export * from "./myBookings.vue?vue&type=script&setup=true&lang=js"

import "./myBookings.vue?vue&type=style&index=0&id=2de217c0&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\rcpetresort.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de217c0"]])

export default __exports__